var _slicedToArray = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var wrapper = require('solc/wrapper');

var abi = require('ethereumjs-abi');

var keccak256 = require('js-sha3').keccak256;

var assert = require('assert');

function getMappingSstore(slotNumber, keyType, key, value) {
  // https://blog.zeppelin.solutions/ethereum-in-depth-part-2-6339cf6bddb9
  var buf = abi.rawEncode([keyType, 'uint256'], [key, slotNumber]);
  var slot = keccak256(buf);
  return "sstore(0x".concat(slot, ", ").concat(value, ")");
} // opts:
// * privSlot: the storage slots used by the proxiedAddr
// * unsafeERC20: true OR safeERC20Artifact
// solcWrapper:
// * wannabe temp solution to work in browsers https://github.com/ethereum/solc-js#browser-usage
// * For node usage: pass ./solc { solcModule }


function getProxyDeployBytecode(proxiedAddr, privLevels, opts, solcModule) {
  assert.ok(opts, 'opts not passed');
  var privSlot = opts.privSlot,
      routineAuthsSlot = opts.routineAuthsSlot;
  assert.ok(typeof privSlot === 'number', 'privSlot must be a number');
  var routineAuthsCode = '';

  if (opts.routineAuthorizations) {
    assert.ok(typeof routineAuthsSlot === 'number', 'routineAuthsSlot must be a number');
    routineAuthsCode = opts.routineAuthorizations.map(function (hash) {
      return getMappingSstore(routineAuthsSlot, 'bytes32', hash, '0x01');
    }).join('\n');
  }

  var privLevelsCode = privLevels.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        addr = _ref2[0],
        level = _ref2[1];

    return getMappingSstore(privSlot, 'address', addr, level);
  }).join('\n');
  var erc20Header = '';
  var feeCode = '';

  if (opts.fee) {
    var fee = opts.fee; // This is fine if we're only accepting whitelisted tokens

    if (fee.unsafeERC20) {
      erc20Header = "interface GeneralERC20 { function transfer(address to, uint256 value) external; }";
      feeCode = "GeneralERC20(".concat(fee.tokenAddr, ").transfer(").concat(fee.recepient, ", ").concat(fee.amount, ");");
    } else {
      assert.ok(fee.safeERC20Artifact, 'opts: either unsafeERC20 or safeERC20Artifact required');
      erc20Header = fee.safeERC20Artifact.source.split('\n').filter(function (x) {
        return !x.startsWith('pragma ');
      }).join('\n');
      feeCode = "SafeERC20.transfer(".concat(fee.tokenAddr, ", ").concat(fee.recepient, ", ").concat(fee.amount, ");");
    }
  }

  var content = "\npragma solidity ^0.5.6;\n".concat(erc20Header, "\ncontract IdentityProxy {\n\tconstructor()\n\t\tpublic\n\t{\n\t\tassembly {\n\t\t\t").concat(privLevelsCode, "\n\t\t\t").concat(routineAuthsCode, "\n\t\t}\n\t\t").concat(feeCode, "\n\t}\n\n\tfunction () external\n\t{\n\t\taddress to = address(").concat(proxiedAddr, ");\n\t\tassembly {\n\t\t\tcalldatacopy(0, 0, calldatasize())\n\t\t\tlet result := delegatecall(sub(gas, 10000), to, 0, calldatasize(), 0, 0)\n\t\t\treturndatacopy(0, 0, returndatasize)\n\t\t\tswitch result case 0 {revert(0, returndatasize)} default {return (0, returndatasize)}\n\t\t}\n\t}\n}");
  var input = {
    language: 'Solidity',
    sources: {
      'Proxy.sol': {
        content: content
      }
    },
    settings: {
      outputSelection: {
        '*': {
          '*': ['evm.bytecode']
        }
      },
      optimizer: {
        enabled: true,
        runs: 200
      }
    }
  };
  var solc = wrapper(solcModule);
  var output = JSON.parse(solc.compile(JSON.stringify(input)));
  assert.ifError(output.errors);
  return "0x".concat(output.contracts['Proxy.sol'].IdentityProxy.evm.bytecode.object);
}

function getStorageSlotsFromArtifact(IdentityArtifact) {
  // Find storage locations of privileges
  var identityNode = IdentityArtifact.ast.nodes.find(function (_ref3) {
    var name = _ref3.name,
        nodeType = _ref3.nodeType;
    return nodeType === 'ContractDefinition' && name === 'Identity';
  });
  assert.ok(identityNode, 'Identity contract definition not found');
  var storageVariableNodes = identityNode.nodes.filter(function (n) {
    return n.nodeType === 'VariableDeclaration' && !n.constant && n.stateVariable;
  });
  var privSlot = storageVariableNodes.findIndex(function (x) {
    return x.name === 'privileges';
  });
  assert.notEqual(privSlot, -1, 'privSlot was not found');
  var routineAuthsSlot = storageVariableNodes.findIndex(function (x) {
    return x.name === 'routineAuthorizations';
  });
  assert.notEqual(routineAuthsSlot, -1, 'routineAuthsSlot was not found');
  return {
    privSlot: privSlot,
    routineAuthsSlot: routineAuthsSlot
  };
}

module.exports = {
  getProxyDeployBytecode: getProxyDeployBytecode,
  getStorageSlotsFromArtifact: getStorageSlotsFromArtifact
};